// const HOST = "https://api.tricontractinginc.com";
// const HOST = "https://api-staging.tricontractinginc.com";
const HOST = process.env.REACT_APP_API_BASE_URL;

export const API_URL = `${HOST}/api/v1`;
export const GRAPHQL_URL = `${HOST}/graphql`;
